module.exports = __webpack_public_path__ + "img/filter.967588a0.svg";